import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Rewards.css';

export default function Rewards() {
    useEffect(() => {
        // Arcade-style background gradient
        document.body.style.background = 'radial-gradient(ellipse at top, #3c1f2b 0%, #1a1a1a 100%)';
        document.body.style.color = '#f5e6d6';
        document.body.style.margin = '0';
        document.body.style.padding = '0';
        document.body.style.fontFamily = `'Noto Sans JP', 'Segoe UI', sans-serif`;

        return () => {
            document.body.style.background = '';
            document.body.style.margin = '';
            document.body.style.padding = '';
            document.body.style.fontFamily = '';
        };
    }, []);

    return (
        <div className="rewards">
            {/* HERO INTRO */}
            <section className="rewards-section intro">
                <h1>
                    Hiro Rewards <span className="kanji-subtitle">ヒロ特典</span>
                </h1>
                <p>
                    Welcome to the Hiro Rewards program — a peaceful way to enjoy more of what you love.
                    Earn points every time you dine, and redeem them for authentic Japanese treats and experiences.
                </p>
            </section>

            {/* FEATURED OFFER */}
            <section className="rewards-section featured-deal">
                <h2>🎉 Sign-Up Bonus</h2>
                <p>
                    Join today and receive <i>100 bonus points</i> just for signing up!
                    That's a head start toward your very first reward.
                </p>
                <Link to="/signup">
                    <button className="reward-button">Join Hiro Rewards</button>
                </Link>
            </section>

            {/* HOW TO EARN */}
            <section className="rewards-section">
                <h2>How to Earn & Redeem</h2>
                <ul>
                    <li>🧾 Earn <i>5 points for every $1 you spend</i> at the buffet!</li>
                    <li>📲 Scan your member QR code at checkout to log your visit</li>
                    <li>📖 Track your points and rewards through your online account</li>
                </ul>
            </section>

            {/* TIERS */}
            <section className="rewards-section">
                <h2>Reward Tiers</h2>
                <ul>
                    <li><strong>100 pts:</strong> Hot tea or bottled water</li>
                    <li><strong>250 pts:</strong> Soft drink or fridge beverage</li>
                    <li><strong>500 pts:</strong> $2 off any gift shop item</li>
                    <li><strong>1000 pts:</strong> $5 off gift shop or seasonal accessory</li>
                    <li><strong>1500 pts:</strong> Free small plush or pair of earrings</li>
                    <li><strong>2500 pts:</strong> Full buffet (weekday only) or $10 shop credit</li>
                </ul>
            </section>

            {/* FAQ */}
            <section className="rewards-section">
                <h2>Frequently Asked Questions</h2>

                <h4>How do I earn points?</h4>
                <p>Sign up and scan your member QR code when you dine. You'll earn <strong>10 points for every dollar spent</strong>.</p>

                <h4>Is there a limit to how many points I can earn at once?</h4>
                <p>Yes — to keep things fair for all our guests, you can earn up to 2,500 points per visit (the equivalent of a $250 spend). Points over that threshold won’t be counted.</p>

                <h4>Do my points expire?</h4>
                <p>Yes, points expire 6 months after they are earned — but that’s plenty of time to enjoy a reward.</p>

                <h4>Can I use a reward and still earn points?</h4>
                <p>Yes! You’ll still earn points on every eligible purchase, even when redeeming a reward.</p>

                <h4>Do I have to redeem all my points at once?</h4>
                <p>
                    No. You can redeem as much or as little as you want during a visit — up to <strong>2,500 points per single transaction</strong>.
                    Think of it like a rewards wallet. If you use 1,000 points on a visit but have 1,500 saved, your remaining points will stay in your account.
                </p>

                <h4>How do I sign up?</h4>
                <p>Click the button below to create your account and start earning points today.</p>

                <Link to="/signup">
                    <button className="signup-button">Sign Up</button>
                </Link>
            </section>
        </div>
    );
}